import { faArrowRight } from "@fortawesome/pro-regular-svg-icons/faArrowRight";
import { faReply } from "@fortawesome/pro-regular-svg-icons/faReply";
import { faTrashCan } from "@fortawesome/pro-regular-svg-icons/faTrashCan";
import { Box, Grid, Stack, TextField, useTheme } from '@mui/material';
import { MprcButton, MprcFormSubHeader, MprcIconFa } from 'components';
import { DirectMessageDto } from 'generated/CoreApi_v1';
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
    canReply: boolean;
    message: DirectMessageDto;
    onDelete: () => void;
    onReply: () => void;
    onForward: () => void;
    onRead: () => void;
}

export const ViewDirectMessage: React.FC<IProps> = (props) => {

    const { canReply, message, onDelete, onReply, onForward, onRead } = props;

    const { t } = useTranslation();
    const theme = useTheme();

    useEffect(() => {
        if (!message.read) onRead();
    }, [message]);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <Box sx={{
            backgroundColor: theme.palette.paper.main,
            border: "1px solid #788898",
            borderRadius: "4px",
            padding: "8px",
            paddingBottom: 0
        }}>
            <Grid container alignItems="center" marginBottom={1}>
                <Grid size="grow">
                    <MprcFormSubHeader title={t("DirectMessage.View.Title")} />
                </Grid>
                <Grid>
                    <Stack direction="row" spacing={8}>
                        {
                            canReply &&
                            <MprcButton
                                text={t("DirectMessage.View.ReplyButtonText")}
                                startIcon={<MprcIconFa icon={faReply} />}
                                color="muted"
                                size="small"
                                onClick={onReply}
                            />
                        }
                        <MprcButton
                            text={t("DirectMessage.View.ForwardButtonText")}
                            startIcon={<MprcIconFa icon={faArrowRight} />}
                            color="muted"
                            size="small"
                            onClick={onForward}
                        />
                        <MprcButton
                            text={t("DirectMessage.View.DeleteButtonText")}
                            startIcon={<MprcIconFa icon={faTrashCan} />}
                            size="small"
                            color="error"
                            onClick={onDelete}
                        />
                    </Stack>
                </Grid>
            </Grid>
            <TextField
                fullWidth
                autoComplete="off"
                multiline
                margin="none"
                variant="standard"
                rows={5}
                value={message.body}
                disabled
            />
        </Box>
    );
};
